import { useMutation } from '@apollo/react-hooks';
import { growlErrors } from '../utils/NotificationUtil';
import gql from 'graphql-tag';
import { useContext } from 'react';
import { NotificationContext } from '../components/GrowlNotifications';

const GET_STRIPE_HOSTED_INVOICE_URL_MUTATION = gql`
  mutation getStripeInvoiceHostedUrlMutation($input: GetStripeInvoiceHostedUrlInput!) {
    getStripeInvoiceHostedUrl(input: $input) {
      stripeHostedInvoiceUrl
    }
  }
`;

const useStripeInvoice = () => {
  const growl = useContext(NotificationContext);
  const [getStripeHostedInvoiceUrlMutation] = useMutation(GET_STRIPE_HOSTED_INVOICE_URL_MUTATION);

  const redirectToStripeHostedInvoiceUrl = async (managingAccountId, clientAccountId, stripeInvoiceId) => {
    try {
      const {
        data: {
          getStripeInvoiceHostedUrl: { stripeHostedInvoiceUrl },
        },
      } = await getStripeHostedInvoiceUrlMutation({
        variables: {
          input: {
            managingAccountId,
            clientAccountId,
            stripeInvoiceId,
          },
        },
      });

      window.open(stripeHostedInvoiceUrl, '_blank', 'noreferrer');
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  return {
    redirectToStripeHostedInvoiceUrl,
  };
};

export default useStripeInvoice;
